import { forwardRef, useState } from "react";
import CSS from "./styles.module.css";

/**
 * TextBox component by © MTTP://SignatureUI
 *
 * List of Props supported:
 *  - type (Choose various Input types)
 *  - variant (Choose one of the Variants of the component)
 *  - placeholder (Pass placeholder text as string)
 *  - leftActionArea (Clickable action area on the left side of the TextBox, pass icons/components)
 *  - rightActionArea (Clickable action area on the left side of the TextBox, pass icons/components)
 *  - leftIcon (Set true if an Icon is passed in the left area)
 *  - rightIcon (Set true if an Icon is passed in the right area)
 *  - className (Pass a custom className)
 *  - id (Pass id as string)
 *  - value (Pass TextBox's value)
 *  - defaultValue (Pass TextBox's default value)
 *  - inactive (pass true to inactive TextBox)
 *  - autoFocus (true/false)
 *  - onClick (onClick event handler)
 *  - onFocus (onFocus event handler)
 *  - onBlur (onBlur event handler)
 *  - onChange (onChange event handler)
 *  - onKeyUp (onKeyUp event handler)
 *  - onKeyDown (onKeyDown event handler)
 *  - wide (Make TextBox span 100%)
 *
 * @param {{
 * type: 'email' | 'number' | 'password' | 'search' | 'tel' | 'text' | 'url';
 * variant: 'Standard' | 'MessageTextBox' | 'PhoneNumberTextBox' | 'OTPTextBox' | 'Name';
 * placeholder: string;
 * leftActionArea: object;
 * leftIcon: boolean;
 * rightActionArea: object;
 * rightIcon: boolean;
 * className: string;
 * id: string;
 * value: string;
 * defaultValue: string;
 * inactive: boolean;
 * autoFocus: boolean;
 * onClick: object;
 * onFocus: object;
 * onBlur: object;
 * onChange: object;
 * onKeyUp: object;
 * onKeyDown: object;
 * optionalLabel: boolean;
 * requiredLabel: boolean;
 * wide: boolean
 * }}
 *
 */

export const TextBox = forwardRef(
	(
		{
			type,
			variant,
			className,
			placeholder,
			leftIcon,
			rightIcon,
			leftActionArea,
			rightActionArea,
			id,
			onKeyUp,
			onKeyDown,
			onClick,
			onChange,
			onBlur,
			onFocus,
			autoFocus,
			value,
			defaultValue,
			inactive,
			optionalLabel,
			requiredLabel,
			wide,
		},
		ref
	) => {
		const [leftAA] = useState("inputLAA");
		const [rightAA] = useState("inputRAA");

		return (
			<div
				className={`${CSS.input} ${inactive ? CSS.inactive : ""} ${
					variant !== "Standard" && CSS[variant]
				} ${leftActionArea ? CSS[leftAA] : ""} ${
					rightActionArea ? CSS[rightAA] : ""
				} ${className ? className : ""} ${wide ? CSS.wide : ""}`}
			>
				<input
					type={
						variant === "OTPTextBox" || variant === "PhoneNumberTextBox"
							? "number"
							: type
							? type
							: "text"
					}
					autoComplete="nope"
					defaultValue={defaultValue}
					value={value}
					maxLength={variant === "OTPTextBox" ? "1" : ""}
					id={id}
					ref={ref}
					onChange={onChange}
					onClick={onClick}
					onKeyUp={onKeyUp}
					onKeyDown={onKeyDown}
					onFocus={onFocus}
					onBlur={onBlur}
					required
					autoFocus={autoFocus ? true : false}
				/>
				<label>
					{variant === "OTPTextBox"
						? ""
						: placeholder
						? placeholder
						: "Enter text"}
					{optionalLabel && <font className={CSS.opt}> (Optional)</font>}
					{requiredLabel && <font style={{ color: "var(--Red)" }}>*</font>}
				</label>
				{leftActionArea && (
					<div className={`${CSS.ActionArea} ${CSS.left}`}>
						{leftIcon ? (
							<span className="material-symbols-rounded">{leftActionArea}</span>
						) : (
							leftActionArea
						)}
					</div>
				)}
				{rightActionArea && (
					<div className={`${CSS.ActionArea} ${CSS.right}`}>
						{rightIcon ? (
							<span className="material-symbols-rounded">
								{rightActionArea}
							</span>
						) : (
							rightActionArea
						)}
					</div>
				)}
			</div>
		);
	}
);
